import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-campaign-details',
  templateUrl: './campaign-details.component.html',
  styleUrls: ['./campaign-details.component.scss']
})
export class CampaignDetailsComponent implements OnInit {

  campaignId: number;
  campaign: any = null;

  loading = false;
  recipients: any[] = [];
  count = 0;
  page = 1;
  pageSize = 25;
  statusFilter = 'all';

  statuses = ['all', 'Pending', 'Sent', 'Delivered', 'Read', 'Failed', 'Undelivered'];

  constructor(private http: HttpClient, private toastr: ToastrService,
    private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.campaignId = parseInt(this.route.snapshot.paramMap.get('id'), 10);
    this.loadCampaign();
    this.loadRecipients();
  }

  loadCampaign(): void {
    this.http.get<any>(`${environment.serverUrl}/marketing/campaigns/${this.campaignId}`).subscribe({
      next: (res) => { this.campaign = res; },
      error: (e) => {
        console.error('Load campaign failed', e);
        this.toastr.error(e?.error?.error || e?.message || 'Failed to load campaign', 'Error');
      }
    });
  }

  loadRecipients(): void {
    this.loading = true;
    const skip = (this.page - 1) * this.pageSize;
    let url = `${environment.serverUrl}/marketing/campaigns/${this.campaignId}/recipients?skip=${skip}&take=${this.pageSize}`;
    if (this.statusFilter && this.statusFilter !== 'all') { url += `&status=${this.statusFilter}`; }

    this.http.get<any>(url).subscribe({
      next: (res) => {
        this.recipients = res?.data || [];
        this.count = res?.count || 0;
        this.loading = false;
      },
      error: (e) => {
        this.loading = false;
        console.error('Load recipients failed', e);
        this.toastr.error(e?.error?.error || e?.message || 'Failed to load recipients', 'Error');
      }
    });
  }

  refresh(): void {
    this.loadCampaign();
    this.loadRecipients();
  }

  onFilterChange(): void {
    this.page = 1;
    this.loadRecipients();
  }

  onPageChange(page: number): void {
    this.page = page;
    this.loadRecipients();
  }

  statusClass(status: string): string {
    switch ((status || '')) {
      case 'Read': return 'badge bg-success';
      case 'Delivered': return 'badge bg-info text-dark';
      case 'Sent': return 'badge bg-primary';
      case 'Pending': return 'badge bg-secondary';
      case 'Failed':
      case 'Undelivered': return 'badge bg-danger';
      default: return 'badge bg-light text-dark';
    }
  }

  back(): void {
    this.router.navigate(['/whatsapp-bulk/campaigns']);
  }
}
